const theme = {
	colors: {
		primary: '#0A5699',
		secondary: '#91999E',
		success: '#26de81',
		info: '#42DCCB',
		warning: '#D29C49',
		danger: '#F33633',
		text: {
			primary: '#FFFFFF',
			secondary: '#FFFFFF',
		},
		icon: {
			primary: '#91999E',
			secondary: '#FFFFFF',
			active: {
				primary: '#FFFFFF',
				secondary: '#91999E',
			},
		},
		landing: {
			primary: '#0A5699',
			text: {
				primary: '#000000',
				secondary: '#FFFFFF',
			},
			icon: {
				primary: '#0A5699',
				secondary: '#FFFFFF',
			},
			hideBackgroundGradient: false,
		},
	},
	transitions: {
		duration: '0.25s',
	},
	font: {
		size: '12px',
	},
};

export default theme;
